import React from "react";

export default function SuperAdminHome() {
  return (
    <div style={{ padding: "40px", fontFamily: "Arial" }}>
      <h1>CloudGenomics Super Admin Portal</h1>
      <p>Welcome, CloudGenomics administrator.</p>
      <p>This is the internal control panel for managing organizations.</p>
    </div>
  );
}